import { render } from "./RuiNoData.vue?vue&type=template&id=4e475c4d&scoped=true"
import script from "./RuiNoData.vue?vue&type=script&lang=ts"
export * from "./RuiNoData.vue?vue&type=script&lang=ts"

import "./RuiNoData.vue?vue&type=style&index=0&id=4e475c4d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4e475c4d"

export default script